(function () {
  const currentUrl = new URL(window.location.href);
  const currentPath = currentUrl.pathname;
  const urlParams = new URLSearchParams(currentUrl.search);

  // Only proceed if:
  // 1. We're on a collection page
  // 2. There's something after /collections/ (like 'all', 'men', etc.)
  // 3. The filter is not already present
  if (
    currentPath.includes("/collections/") &&
    currentPath !== "/collections/" &&
    currentPath !== "/collections" &&
    !urlParams.has("filter.v.availability")
  ) {
    // Block page render until filter is applied
    document.documentElement.style.display = "none";

    // Add the filter parameter
    urlParams.set("filter.v.availability", "1");
    const newUrl = `${currentPath}?${urlParams.toString()}`;

    // Redirect to filtered URL
    window.location.href = newUrl;
  }
})();

// After page load, handle checkbox state and changes
document.addEventListener("DOMContentLoaded", function () {
  const filterForm = document.querySelector("[data-collection-filters-form]");
  if (filterForm) {
    const availabilityInput = filterForm.querySelector(
      'input[name*="filter.v.availability"][value*="1"]'
    );

    if (availabilityInput) {
      // Set initial state
      availabilityInput.checked = window.location.search.includes(
        "filter.v.availability=1"
      );

      // Handle checkbox changes
      availabilityInput.addEventListener("change", function (e) {
        e.preventDefault(); // Prevent default form behavior

        const currentUrl = new URL(window.location.href);
        const urlParams = new URLSearchParams(currentUrl.search);

        if (!this.checked) {
          // Remove the availability parameter
          urlParams.delete("filter.v.availability");
        } else {
          // Add the availability parameter if checked
          urlParams.set("filter.v.availability", "1");
        }

        // Create new URL
        const newUrl = `${currentUrl.pathname}${
          urlParams.toString() ? "?" + urlParams.toString() : ""
        }`;

        // Update URL without reload
        window.history.pushState({}, "", newUrl);

        // Use theme's filter update event
        const filterUpdateEvent = new CustomEvent("theme:filter:update", {
          detail: { href: newUrl },
          bubbles: true,
        });
        filterForm.dispatchEvent(filterUpdateEvent);
      });

      // Prevent form from handling the checkbox change
      filterForm.addEventListener(
        "change",
        function (e) {
          if (e.target === availabilityInput) {
            e.stopPropagation();
          }
        },
        true
      );

      // Listen for theme's filter change events
      document.addEventListener("theme:filter:update", function (e) {
        if (e.detail && e.detail.href) {
          const newUrl = new URL(e.detail.href, window.location.origin);
          availabilityInput.checked = newUrl.searchParams.has(
            "filter.v.availability"
          );
        }
      });
    }
  }
});